/* eslint-disable import/prefer-default-export */

export const initialTestTripProfileStr = `{
  "config": {
    "score_config": {
      "distance": {
        "weight": 300,
        "sensitivity": 40,
        "effect": "-"
      },
      "keyword": {
        "weight": 1500,
        "sensitivity": 0.04,
        "effect": "+"
      },
      "rating": {
        "weight": 10,
        "sensitivity": 0.05,
        "effect": "+"
      },
      "popularity": {
        "weight": 20,
        "sensitivity": 50,
        "effect": "+"
      }
    },
    "answers_config": [
      {
        "id": 1,
        "category_ids": [3, 24, 33],
        "keywords": [670, 10858]
      },
      {
        "id": 2,
        "category_ids": [33, 3, 24],
        "keywords": [685, 10894]
      },
      {
        "id": 5,
        "category_ids": [1, 25, 26, 28, 29, 30, 32],
        "keywords": [8656]
      },
      {
        "id": 6,
        "category_ids": [1, 32],
        "keywords": [8385, 234, 251]
      },
      {
        "id": 12,
        "category_ids": [1, 25, 26, 28, 29, 30, 32],
        "keywords": [8629]
      },
      {
        "id": 13,
        "category_ids": [8, 1],
        "keywords": [64, 2770, 8862]
      },
      {
        "id": 16,
        "category_ids": [1, 25, 26, 28, 29, 30, 32],
        "keywords": [8629]
      },
      {
        "id": 18,
        "category_ids": [30],
        "keywords": [108]
      },
      {
        "id": 25,
        "category_ids": [1, 8],
        "keywords": [64, 2770]
      },
      {
        "id": 27,
        "category_ids": [1, 4, 8, 24, 31],
        "keywords": [9118]
      },
      {
        "id": 32,
        "category_ids": [3],
        "keywords": [8928],
        "filter": {
          "types": [3],
          "rule": "price<",
          "order": 4
        }
      },
      {
        "id": 402,
        "category_ids": [3],
        "keywords": [8928],
        "filter": {
          "types": [3],
          "rule": "price<",
          "order": 7
        }
      },
      {
        "id": 401,
        "category_ids": [3],
        "keywords": [153, 295, 10994],
        "filter": {
          "types": [3],
          "rule": "price>",
          "order": 7
        }
      },
      {
        "id": 34,
        "category_ids": [3],
        "keywords": [153, 295, 10994],
        "filter": {
          "types": [3],
          "rule": "price>",
          "order": 4
        }
      },
      {
        "id": 35,
        "category_ids": [1, 25, 28, 29],
        "keywords": [8640, 8431, 20564, 7747, 8708, 8943, 8377, 22554]
      },
      {
        "id": 101,
        "category_ids": [26, 28, 29, 30, 32],
        "keywords": [8629, 8656]
      },
      {
        "id": 102,
        "category_ids": [1, 25, 26, 28, 29, 32],
        "keywords": [8653, 10927, 754, 104, 10953]
      },
      {
        "id": 103,
        "category_ids": [1, 25, 26, 28, 29, 32],
        "keywords": [8685, 102, 105, 10971, 5474]
      },
      {
        "id": 104,
        "category_ids": [1, 25, 26, 28, 29, 32],
        "keywords": [574, 8220]
      },
      {
        "id": 105,
        "category_ids": [30],
        "keywords": [8629]
      },
      {
        "id": 106,
        "category_ids": [1, 30, 32],
        "keywords": [1025, 10889]
      },
      {
        "id": 107,
        "category_ids": [1, 30],
        "keywords": [8383]
      },
      {
        "id": 108,
        "category_ids": [1, 30],
        "keywords": [8344]
      },
      {
        "id": 109,
        "category_ids": [1, 30],
        "keywords": [8227]
      },
      {
        "id": 110,
        "category_ids": [1, 30, 32],
        "keywords": [1025, 10889]
      },
      {
        "id": 111,
        "category_ids": [1, 30, 32],
        "keywords": [8385, 234]
      },
      {
        "id": 112,
        "category_ids": [1, 30, 32],
        "keywords": [1157, 8764, 9531]
      },
      {
        "id": 113,
        "category_ids": [1, 30, 32],
        "keywords": []
      },
      {
        "id": 114,
        "category_ids": [1, 30, 32],
        "keywords": []
      },
      {
        "id": 115,
        "category_ids": [1, 30, 32],
        "keywords": []
      },
      {
        "id": 116,
        "category_ids": [1, 30, 32],
        "keywords": []
      },
      {
        "id": 117,
        "category_ids": [1, 30, 32],
        "keywords": []
      },
      {
        "id": 118,
        "category_ids": [1, 30, 32],
        "keywords": []
      }
    ]
  },
  "days": [
    {
      "params": {
        "city_id": 109,
        "date": "2021-11-28",
        "start_time": "09:00",
        "end_time": "18:00",
        "companion_ids": [1, 3, 4],
        "adult_no": 4,
        "child_no": 1,
        "age_avg": 35,
        "answers": [16, 5, 18, 6, 12, 34, 24, 25, 26, 106],
        "accommodation": {
          "ref_id": "string",
          "name": "string",
          "address": "string",
          "coordinate": {
            "lat": 41.3850639,
            "lng": 2.17340349
          }
        }
      },
      "steps_config": [
        {
          "timeframe": [900, 1000],
          "poi_types": [3],
          "order": 1,
          "score_config": {
            "distance": {
              "weight": 30000
            }
          }
        },
        {
          "timeframe": [1000, 1130],
          "poi_types": [1, 8, 25, 26, 28, 29, 30, 32, 34],
          "order": 2
        },
        {
          "timeframe": [1130, 1230],
          "poi_types": [1, 8, 25, 26, 28, 29, 30, 32, 34],
          "order": 3
        },
        {
          "timeframe": [1230, 1330],
          "poi_types": [3],
          "order": 4
        },
        {
          "timeframe": [1330, 1530],
          "poi_types": [1, 8, 25, 26, 28, 29, 30, 32, 34],
          "order": 5
        },
        {
          "timeframe": [1530, 1730],
          "poi_types": [1, 8, 25, 26, 28, 29, 30, 32, 34],
          "order": 6
        },
        {
          "timeframe": [1730, 2000],
          "poi_types": [3],
          "order": 7
        },
        {
          "timeframe": [2000, 2400],
          "poi_types": [31, 35, 4],
          "order": 8
        }
      ]
    }
  ]
}`;

/* const initialTestTripProfile: TestModel.ITestTripProfile = {
  config: {
    score_config: {
      distance: {
        weight: 300,
        sensitivity: 40,
        effect: '-',
      },
      keyword: {
        weight: 1500,
        sensitivity: 0.04,
        effect: '+',
      },
      rating: {
        weight: 10,
        sensitivity: 0.05,
        effect: '+',
      },
      popularity: {
        weight: 20,
        sensitivity: 50,
        effect: '+',
      },
    },
    answers_config: [
      {
        id: 1,
        category_ids: [3, 24, 33],
        keywords: [670, 10858],
      },
      {
        id: 2,
        category_ids: [33, 3, 24],
        keywords: [685, 10894],
      },
      {
        id: 5,
        category_ids: [1, 25, 26, 28, 29, 30, 32],
        keywords: [8656],
      },
      {
        id: 6,
        category_ids: [1, 32],
        keywords: [8385, 234, 251],
      },
      {
        id: 12,
        category_ids: [1, 25, 26, 28, 29, 30, 32],
        keywords: [8629],
      },
      {
        id: 13,
        category_ids: [8, 1],
        keywords: [64, 2770, 8862],
      },
      {
        id: 16,
        category_ids: [1, 25, 26, 28, 29, 30, 32],
        keywords: [8629],
      },
      {
        id: 18,
        category_ids: [30],
        keywords: [108],
      },
      {
        id: 25,
        category_ids: [1, 8],
        keywords: [64, 2770],
      },
      {
        id: 27,
        category_ids: [1, 4, 8, 24, 31],
        keywords: [9118],
      },
      {
        id: 32,
        category_ids: [3],
        keywords: [8928],
        filter: {
          types: [3],
          rule: 'price<',
          order: 4,
        },
      },
      {
        id: 402,
        category_ids: [3],
        keywords: [8928],
        filter: {
          types: [3],
          rule: 'price<',
          order: 7,
        },
      },
      {
        id: 401,
        category_ids: [3],
        keywords: [153, 295, 10994],
        filter: {
          types: [3],
          rule: 'price>',
          order: 7,
        },
      },
      {
        id: 34,
        category_ids: [3],
        keywords: [153, 295, 10994],
        filter: {
          types: [3],
          rule: 'price>',
          order: 4,
        },
      },
      {
        id: 35,
        category_ids: [1, 25, 28, 29],
        keywords: [8640, 8431, 20564, 7747, 8708, 8943, 8377, 22554],
      },
      {
        id: 101,
        category_ids: [26, 28, 29, 30, 32],
        keywords: [8629, 8656],
      },
      {
        id: 102,
        category_ids: [1, 25, 26, 28, 29, 32],
        keywords: [8653, 10927, 754, 104, 10953],
      },
      {
        id: 103,
        category_ids: [1, 25, 26, 28, 29, 32],
        keywords: [8685, 102, 105, 10971, 5474],
      },
      {
        id: 104,
        category_ids: [1, 25, 26, 28, 29, 32],
        keywords: [574, 8220],
      },
      {
        id: 105,
        category_ids: [30],
        keywords: [8629],
      },
      {
        id: 106,
        category_ids: [1, 30, 32],
        keywords: [1025, 10889],
      },
      {
        id: 107,
        category_ids: [1, 30],
        keywords: [8383],
      },
      {
        id: 108,
        category_ids: [1, 30],
        keywords: [8344],
      },
      {
        id: 109,
        category_ids: [1, 30],
        keywords: [8227],
      },
      {
        id: 110,
        category_ids: [1, 30, 32],
        keywords: [1025, 10889],
      },
      {
        id: 111,
        category_ids: [1, 30, 32],
        keywords: [8385, 234],
      },
      {
        id: 112,
        category_ids: [1, 30, 32],
        keywords: [1157, 8764, 9531],
      },
      {
        id: 113,
        category_ids: [1, 30, 32],
        keywords: [],
      },
      {
        id: 114,
        category_ids: [1, 30, 32],
        keywords: [],
      },
      {
        id: 115,
        category_ids: [1, 30, 32],
        keywords: [],
      },
      {
        id: 116,
        category_ids: [1, 30, 32],
        keywords: [],
      },
      {
        id: 117,
        category_ids: [1, 30, 32],
        keywords: [],
      },
      {
        id: 118,
        category_ids: [1, 30, 32],
        keywords: [],
      },
    ],
  },
  days: [
    {
      params: {
        city_id: 109,
        date: '2021-11-28',
        start_time: '09:00',
        end_time: '18:00',
        companion_ids: [1, 3, 4],
        adult_no: 4,
        child_no: 1,
        age_avg: 35,
        answers: [16, 5, 18, 6, 12, 34, 24, 25, 26, 106],
        accommodation: {
          ref_id: 'string',
          name: 'string',
          address: 'string',
          coordinate: {
            lat: 41.3850639,
            lng: 2.1734034999999494,
          },
        },
      },
      steps_config: [
        {
          timeframe: [900, 1000],
          poi_types: [3],
          order: 1,
          score_config: {
            distance: {
              weight: 30000,
            },
          },
        },
        {
          timeframe: [1000, 1130],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 2,
        },
        {
          timeframe: [1130, 1230],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 3,
        },
        {
          timeframe: [1230, 1330],
          poi_types: [3],
          order: 4,
        },
        {
          timeframe: [1330, 1530],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 5,
        },
        {
          timeframe: [1530, 1730],
          poi_types: [1, 8, 25, 26, 28, 29, 30, 32, 34],
          order: 6,
        },
        {
          timeframe: [1730, 2000],
          poi_types: [3],
          order: 7,
        },
        {
          timeframe: [2000, 2400],
          poi_types: [31, 35, 4],
          order: 8,
        },
      ],
    },
  ],
}; */
